<template>
  <span class="stars">
    <img
      v-for="index in stars"
      :key="index"
      @click="changeStars(index)"
      :style="{width: starWidth + 'px', height: starWidth + 'px', marginRight: starMargin + 'px'}"
      :class="{clickable: clickable}"
      src="../../../static/img/meals/icon_pl_star.png">
    <img
      v-if="stars < 5"
      v-for="index in (5 - stars)"
      :key="index + 5"
      @click="changeStars(index + stars)"
      :style="{width: starWidth + 'px', height: starWidth + 'px', marginRight: starMargin + 'px'}"
      :class="{clickable: clickable}"
      src="../../../static/img/meals/icon_pl_star_pre.png">
  </span>
</template>

<script>
export default {
  name: 'Stars',
  props: {
    stars: {
      type: Number,
      default: 0
    },
    starWidth: {
      type: Number,
      default: 14
    },
    starMargin: {
      type: Number,
      default: 2
    },
    clickable: {
      type: Boolean,
      default: false
    },
    starIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    changeStars (num) {
      let params = {
        num: num,
        starIndex: this.starIndex
      }
      this.$store.commit('change_active_stars', params)
    }
  }
}
</script>

<style lang="less" scoped>
.stars {
  display: flex;
  align-items: center;
  .clickable {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/stars.vue